export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="terms-page">
      <div className="overline text-[#4A1525] mb-4">Legal</div>
      <h1 className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95] mb-4">Terms of service.</h1>
      <p className="text-[#5C5C5C] mb-16">Last updated: February 2026</p>

      <div className="space-y-10 text-[#1A1A1A] leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl mb-3">1. Acceptance of terms</h2>
          <p className="text-[#5C5C5C]">By accessing or purchasing from iamravishing.com (the "Site"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Site.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">2. Eligibility</h2>
          <p className="text-[#5C5C5C]">You must be at least 18 years old to purchase from Iamravishing. By placing an order you confirm that you meet this requirement and that the information you provide is accurate.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">3. Products & pricing</h2>
          <p className="text-[#5C5C5C]">All items are handmade in limited runs. Slight variations in colour, texture, and finish are part of the character of hand-crafted lingerie. Prices are listed in USD and may be subject to change without notice. Any offer is valid while stocks last.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">4. Orders & payment</h2>
          <p className="text-[#5C5C5C]">Placing an order is an offer to purchase, which we may accept or decline. Payment is charged at the time of order via Stripe or on delivery for Cash on Delivery orders. We reserve the right to cancel orders where pricing has been listed in error or where fraud is suspected.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">5. Shipping & returns</h2>
          <p className="text-[#5C5C5C]">Shipping estimates and return policies are outlined on our <a href="/shipping-returns" className="text-[#4A1525] underline underline-offset-4">Shipping & Returns</a> page and are incorporated by reference into these Terms.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">6. Intellectual property</h2>
          <p className="text-[#5C5C5C]">All content on this Site — including designs, imagery, copy, and the Iamravishing name and logo — is the property of Iamravishing and protected by copyright and trademark law. You may not reproduce, distribute, or use any material without written permission.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">7. User accounts</h2>
          <p className="text-[#5C5C5C]">You are responsible for maintaining the confidentiality of your account credentials and for any activity that occurs under your account. Notify us immediately of any unauthorized use.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">8. Limitation of liability</h2>
          <p className="text-[#5C5C5C]">To the fullest extent permitted by law, Iamravishing shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Site or purchase of our products.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">9. Governing law</h2>
          <p className="text-[#5C5C5C]">These Terms are governed by the laws of India. Any disputes will be resolved in the courts of Mumbai.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">10. Contact</h2>
          <p className="text-[#5C5C5C]">For questions about these Terms, email us at <a href="mailto:admin@iamravishing.com" className="text-[#4A1525] underline underline-offset-4">admin@iamravishing.com</a>.</p>
        </section>
      </div>
    </div>
  );
}
